/** Up to two initials of a display name (first and last word), upper-cased in the user's locale. */
export function initialsOf(name: string): string {
  const words = name
    .trim()
    .split(/\s+/u)
    .filter((word) => word.length > 0);
  const first = words[0];
  if (first === undefined) return "";
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  const letter = (word: string) => Array.from(word)[0] ?? "";
  return (letter(first) + (last === undefined ? "" : letter(last))).toLocaleUpperCase();
}
